import React from 'react';
import './slider-polysorbwall.css';
import Polysorbwall1 from '../../images/polysorb/wall1.webp';
import Polysorbwall2 from '../../images/polysorb/wall1.webp';
function slider() {
	return (
	  
	<>
	<div id="slider-polysorbwall">
		<div id="carouselExampleIndicators2" className="carousel slide" data-ride="carousel">
  			<ol className="carousel-indicators">
    			<li data-target="#carouselExampleIndicators2" data-slide-to="0" className="active"></li>
    			<li data-target="#carouselExampleIndicators2" data-slide-to="1"></li>
  			</ol>
  			<div className="carousel-inner">
    			<div className="carousel-item active">
      				<img className="d-block w-100" src={Polysorbwall1} alt="Polysorb wall1" />
	  				<div className="carousel-caption d-none d-md-block">
					  	<h1>ACOUSTICAL WALL PANELS</h1>
					</div>
				</div>
    			<div className="carousel-item">
      				<img className="d-block w-100" src={Polysorbwall2} alt="Polysorb wall2" />
	  				<div className="carousel-caption d-none d-md-block">
					  	<h1>ACOUSTICAL WALL PANELS</h1>
					</div>
				</div>
			</div>
  			<a className="carousel-control-prev" href="#carouselExampleIndicators2" role="button" data-slide="prev">
    			<span className="carousel-control-prev-icon" aria-hidden="true"></span>
    			<span className="sr-only">Previous</span>
  			</a>
  			<a className="carousel-control-next" href="#carouselExampleIndicators2" role="button" data-slide="next">
    			<span className="carousel-control-next-icon" aria-hidden="true"></span>
    			<span className="sr-only">Next</span>
  			</a>
		</div>
	</div>
	</>
);
}
export default slider;